import React from 'react';

import { TrialsPageHeaderWrapper } from 'screens/Trials/styles';
import PodiumLogo from '../../PodiumLogo';

export const TrialsPageHeader = () => (
  <TrialsPageHeaderWrapper>
    <PodiumLogo icon={true} />
  </TrialsPageHeaderWrapper>
);
